///<reference path="commons/xhr.ts" />
///<reference path="typings/jquery.d.ts" />
///<reference path="commons/cookie.ts" />
var commonController = /** @class */ (function () {
    function commonController() {
        this.scheduleUrl = "/action/tv_guide";
        this.scheduleImageServiceUrl = "//s.duhnet.tv/ps/tv2/98/738x415/";
        if (document.querySelector('#represantiveForm') !== null) {
            this.initRepresantativeFormListener();
        }
        if (document.querySelector('#wordGameForm') !== null) {
            //this.initWordGameFormListener();
            this.initWordGameFormListenerFormData();
        }
        if (document.querySelector('.section-live-play-detail') !== null) {
            this.scheduleUpdateListener();
        }
        if (!Cookie.getCookie('cookieAccepted')) {
            this.showCookiePolicy();
        }
    }
    commonController.prototype.showCookiePolicy = function () {
        var cookieElement = document.getElementById('cookiePolicy');
        if (cookieElement !== null) {
            cookieElement.style.display = "block";
            var closeButton = document.querySelector('.cookie-area .close-btn');
            closeButton.addEventListener('click', function () {
                var timestamp = new Date();
                var time = timestamp.getTime();
                time += 60 * 60 * 24 * 60 * 1000;
                timestamp.setTime(time);
                Cookie.setCookie('cookieAccepted', 'true', timestamp);
                cookieElement.style.display = "none";
            });
        }
    };
    commonController.prototype.scheduleUpdateListener = function () {
        var _this = this;
        setInterval(function () {
            _this.getCurrentSchedule();
        }, 600000);
    };
    commonController.prototype.getCurrentSchedule = function () {
        var _this = this;
        var xhr = new Xhr();
        var requestUrl = this.scheduleUrl;
        xhr.getJSON(requestUrl, function (data) {
            _this.updateScheduleBar(data);
        }, function (status) {
            console.log("YUKLEME HATASI");
        });
    };
    commonController.prototype.updateScheduleBar = function (data) {
        var programInfo = [
            {
                "time": data[0].StartTime.slice(11, 16),
                "title": data[0].Title
            },
            {
                "time": data[1].StartTime.slice(11, 16),
                "title": data[1].Title
            },
            {
                "time": data[2].StartTime.slice(11, 16),
                "title": data[2].Title
            },
            {
                "activeImage": this.scheduleImageServiceUrl + data[0].ContentId
            }
        ];
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-time')[0].innerHTML = programInfo[0].time;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-program-name')[0].innerHTML = programInfo[0].title;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-time')[1].innerHTML = programInfo[1].time;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-program-name')[1].innerHTML = programInfo[1].title;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-time')[2].innerHTML = programInfo[2].time;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-program-name')[2].innerHTML = programInfo[2].title;
        var blurredBg = document.querySelector('.blurred-bg');
        blurredBg.style.background = "url('" + programInfo[3].activeImage + "')";
    };
    commonController.prototype.selectListAutoWidth = function () {
        $(document).ready(function () {
            if ($("#resizing_select")) {
                $("#width_tmp_option").html($('#resizing_select option:selected').text());
                $("#resizing_select").width($("#width_tmp_select").width() - 15);
            }
        });
    };
    commonController.prototype.initRepresantativeFormListener = function () {
        var formElement = $('#represantiveForm');
        var _this = this;
        formElement.validator().on('submit', function (e) {
            if (e.isDefaultPrevented()) {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
            else {
                e.stopImmediatePropagation();
                e.preventDefault();
                var data = {
                    "Message": {
                        "Ad": $('#name').val(),
                        "Soyad": $('#surname').val(),
                        "Email": $('#email').val(),
                        "Doğum Tarihi": $('#birthdate').val(),
                        "İl": $('#city').val(),
                        "İlçe": $('#district').val(),
                        "Cinsiyet": $('#gender').val(),
                        "Yazma Nedeni": $('#reason').val(),
                        "Program Adı": $('#programs').val(),
                        "Yayın Tarihi": $('#broadcast-date').val(),
                        "Yayın Saati": $('#broadcast-time').val(),
                        "Mesajınız": $('#message').val()
                    }
                };
                data = JSON.stringify(data);
                $.ajax({
                    type: "POST",
                    url: "/action/send_contact_form",
                    data: data,
                    success: function (result) {
                        if (result === '{"result": true}') {
                            _this.formResultOperations(true, 'represantiveForm');
                        }
                        else {
                            _this.formResultOperations(false, 'represantiveForm');
                        }
                    }
                });
            }
        });
    };
    commonController.prototype.serializeObject = function (object) {
        var serializedObj = {};
        var arr = object.serializeArray();
        $.each(arr, function (index, elem) {
            if (serializedObj[elem.name] !== undefined) {
                if (!serializedObj[elem.name].push) {
                    serializedObj[elem.name] = [serializedObj[elem.name]];
                }
                serializedObj[elem.name].push(elem.value || '');
            }
            else {
                serializedObj[elem.name] = elem.value || '';
            }
        });
        return serializedObj;
    };
    commonController.prototype.getBase64 = function (file, callback) {
        var reader = new FileReader();
        if (typeof file !== 'undefined') {
            reader.onload = callback;
            reader.readAsDataURL(file);
        }
    };
    commonController.prototype.initWordGameFormListenerFormData = function () {
        var formElement = $('#wordGameForm'), _this = this;
        var loadingDiv = $('<div />', {
            class: 'loading-block',
            title: 'Lütfen bekleyin...'
        });
        loadingDiv.html('Başvuru formunuz kayıt ediliyor, lütfen birkaç saniye bekleyiniz...');
        formElement.find('input:file').on('change', function () {
            $(this).parent().siblings('.placeholder-label').html(this.files[0].name);
        });
        formElement.on('submit', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            var formData = new FormData(this);
            loadingDiv.appendTo('body');
            $.ajax({
                url: 'https://form.tv2.com.tr/userforms',
                data: formData,
                type: "POST",
                crossDomain: true,
                contentType: false,
                processData: false,
                cache: false,
                timeout: 0
            }).done(function (data) {
                loadingDiv.remove();
                _this.formResultOperations(true, 'wordGameForm');
            }).fail(function () {
                loadingDiv.remove();
                _this.formResultOperations(false, 'wordGameForm');
            });
        });
    };
    commonController.prototype.formResultOperations = function (result, element) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        var formResult = $('#formResult');
        var submitBtn = $('#wordGameForm [type="submit"]');
        $(submitBtn).text('Gönder').removeAttr("disabled");
        if (element === 'represantiveForm') {
            formResult = $('#formResultModal');
            if (result) {
                document.getElementById(element).reset();
                formResult.find('.icon').removeClass('type-error');
                formResult.find('.icon').html("<img class=\"img-fluid\" src=\"" + formResult.attr('data-success-img') + "\" alt=\"\" />");
                formResult.find('.modal-title').text('Mesajınız Bize Ulaştı!');
                formResult.find('.modal-desc').html('<p>Görüş ve önerileriniz bizim için çok değerli.<br />İlginiz için teşekkür ederiz!</p>');
            }
            else {
                formResult.find('.icon').addClass('type-error');
                formResult.find('.icon').html("<img class=\"img-fluid\" src=\"" + formResult.attr('data-error-img') + "\" alt=\"\" />");
                formResult.find('.modal-title').text('Bir Hata Oluştu!');
                formResult.find('.modal-desc').html('<p>Mesajınız gönderilemedi. Lütfen tekrar deneyiniz.</p>');
            }
            if (formResult.length === 0 || typeof formResult.modal !== 'function') {
                return false;
            }
            formResult.modal('show');
        }
        else {
            formResult.show();
            formResult.removeClass('bg-danger').removeClass('bg-success');
            if (result) {
                formResult.addClass('bg-success');
                document.getElementById(element).reset();
                document.querySelector('.placeholder-label').innerHTML = '';
                formResult.text('Kaydınız başarıyla alınmıştır. Bizimle iletişime geçtiğiniz için teşekkür ederiz.');
            }
            else {
                formResult.addClass('bg-danger');
                formResult.text('Form Gönderilirken bir hata oluştu lütfen tekrar deneyiniz');
            }
            setTimeout(function () {
                formResult.fadeOut('fast');
            }, 5000);
        }
    };
    commonController.prototype.initNanoScrollers = function () {
        $(".desc-info.nano").nanoScroller({
            alwaysVisible: true
        });
        $(".playlist-container.nano").nanoScroller({
            alwaysVisible: true
        });
    };
    commonController.prototype.initLazyLoad = function () {
        $("img.lazy").unveil();
    };
    commonController.prototype.initReadMoreToggle = function () {
        $('.readmore').readmore({
            speed: 50,
            moreLink: '<a class="readmoreToggle" href="#">Daha Fazlası</a>',
            lessLink: '<a class="readmoreToggle" href="#">Açıklamayı Daralt</a>',
            embedCSS: false,
            collapsedHeight: 49
        });
    };
    /* autoHeightController() {
         setTimeout(function () {
             if($('.general-container').offset().top < 30) {
                 $('.masthead').css('height', 0);
             }
         }, 5000);
     }*/
    commonController.prototype.browserChecker = function () {
        if (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv 11/)) || /Edge/.test(navigator.userAgent)) {
            $('body').addClass('internet-explorer');
        }
    };
    commonController.prototype.initLightbox = function () {
        var lightbox = $('#lightbox-video');
        var lightboxHide = Cookie.getCookie('lightbox');
        var _saci = Cookie.getCookie('_saci');
        var _samr = Cookie.getCookie('_samr');
        var stats_api = false;
        if (_saci !== false)
            stats_api = true;
        else if (_samr !== false && _samr == "2")
            stats_api = true;
        // lightbox elementi yoksa || mobil cihazsa || cookie oluşmuşsa
        if (lightbox.length === 0 || window.outerWidth < 768 || lightboxHide !== false) {
            return false;
        }
        if (typeof lightbox.modal !== 'function') {
            return false;
        }
        /*         lightbox.on('hidden.bs.modal', function (e) {
                    console.log('hidden.bs.modal');
                }); */
        /*
        lightbox.on('shown.bs.modal', function (e) {
            console.log('shown.bs.modal');
        }); */
        lightbox.modal('show');
        var timestamp = new Date();
        var time = timestamp.getTime();
        time += 60 * 60 * 24 * 1000;
        timestamp.setTime(time);
        Cookie.setCookie('lightbox', true, timestamp);
    };
    commonController.prototype.initHeader = function () {
        var navbar = $('.header .navbar');
        if (navbar.length > 0) {
            var navbarCollapse = navbar.find('#navbarResponsive');
            navbarCollapse.on('hide.bs.collapse', function () {
                navbar.removeClass('navbar-collapse');
            });
            navbarCollapse.on('show.bs.collapse', function () {
                navbar.addClass('navbar-collapse');
            });
        }
    };
    return commonController;
}());
var commons = new commonController();
commons.selectListAutoWidth();
commons.initNanoScrollers();
commons.initLazyLoad();
commons.initReadMoreToggle();
//commons.autoHeightController();
commons.browserChecker();
commons.initHeader();
$(document).ready(function () {
    commons.initLightbox();
});
//# sourceMappingURL=common.js.map
